import * as React from 'react'
import { OptionProps } from 'react-select'
import { OrderNumberOption } from './types'
import { useMutation } from 'react-query'
import { toggleJobnumberFavourite } from '../../../api/jobnumbers'

export default function OrderOption(props: OptionProps<OrderNumberOption, false>){
  const { innerRef, innerProps, isDisabled, isFocused, data } = props
  const { jobnumber } = data

  if (isDisabled) {
    return null
  }

  const mutation = useMutation((id: number) => toggleJobnumberFavourite(id), {
    onSuccess: data => {
      // Update the jobnumber's is_favourite property
      jobnumber.is_favourite = data.is_favourite
    },
  })

  const handleFavouriteClick = (e: React.MouseEvent) => {
    e.stopPropagation() // Prevent the row click from selecting the job number
    mutation.mutate(jobnumber.id)
  }

  // Using any to bypass TypeScript's strict type checking for the ref
  // This is necessary because react-select's OptionProps expects a div element ref
  // but we're using a tr element
  return (
    <tr ref={innerRef as any} {...innerProps} className={isFocused ? 'table-active option' : 'option'}>
      <td>
        <span className="mr-2" onClick={handleFavouriteClick} style={{ cursor: 'pointer' }}>
          {mutation.isLoading ? (
            <i className="fas fa-spinner fa-spin" />
          ) : jobnumber.is_favourite ? (
            <i className="fas fa-star text-warning" />
          ) : (
            <i className="far fa-star" />
          )}
        </span>
      </td>
      <td>{jobnumber.job_id}</td>
      <td>{jobnumber.quote_number}</td>
      <td>{jobnumber.order_number}</td>
      <td>{jobnumber.title}</td>
      <td>{jobnumber.customer_title}</td>
    </tr>
  )
}
